import { useState } from "react";


const About = () => {

  const [show, setShow] = useState(false);


    return (  

  

      <div class="about-section" id="about-scroll">
        <h1 class="h1-style">About</h1>

        <div class="summary">

         <p id="quote">"I create visual chemistry with code."</p>

          <p class="hello">Hello! </p>



          <h4>Short Version:</h4>
      
          <p>
     I'm Michael. I built this portfolio website from scratch with React and made it responsive for 
      all devices while debugging along the way. As you can see, I am a visually creative 
      front-end web developer that can create responsive websites from scratch along with 
  version control experience using git. I'm educated in art and communication studies 
    with with a background of photography and design art that compliments my ability to 
    code with a visual user-friendly experience and give clients exactly what they need 
      to keep their clients coming back for more. Contact me if you think I could be a good fit on your team!
          </p>
          

            

            <button onClick={()=>setShow(!show)} id="moreBtn">Click for 2nd Version</button>
         
          
        
            {show?<span id="more">

            
         <p>
  Hi, I'm Michael – a Web Developer with a background in graphic design. 
  I love building responsive, user-friendly websites that bring ideas to life through 
  clean code and creative design.
</p>

<p>
  My journey started in graphic design courses, where I learned the art of visual 
  storytelling. Discovering web development allowed me to combine that creativity 
  with technical skills, and I’ve been hooked ever since.
</p>

<p>
  I specialize in front-end development with HTML, CSS, JavaScript, and React. 
  Every project in this portfolio was built from scratch, showcasing my ability to 
  design, develop, and deliver polished digital experiences.
</p>

<p>
  I'm eager to contribute to a forward-thinking team and continue growing as a developer. 
  If my work resonates with you, let’s connect!
</p>

           
            
            </span>:null }

          <a href="#portfolio-scroll"><button>View my work</button></a>
        </div>
      </div>

      


    );
}
 
export default About;
